import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, InputGroup } from 'react-bootstrap'

const FieldInputChange = ({ TypeOf, input, type, name, label, placeholder, meta: { touched, error, warning }, focus, options, labelKey, key, handleChange, handleBotaoAdicao, selected, referencia, isDisabled, inputGrup }) => {
    return (
        <>
            <Form.Label htmlFor={name}>{label}</Form.Label>

            <InputGroup>
                {inputGrup ? <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">{inputGrup}</InputGroup.Text>
                </InputGroup.Prepend> : null}

                <TypeOf
                    autoFocus={focus}
                    {...input}
                    type={type}
                    name={name}
                    labelKey={labelKey}
                    defaultSelected={selected}
                    key={key}
                    placeholder={placeholder}
                    isInvalid={touched && (error || warning)}
                    options={options}
                    onChange={handleChange}
                    ref={referencia}
                    disabled={isDisabled}
                >
                </TypeOf>
                <Form.Control.Feedback type="invalid">
                    {error}
                </Form.Control.Feedback>

                {/* <InputGroup.Append>
                    <Button title="Editar" size="sm" className="bg-success"> <span className="fa fa-plus" /> </Button>
                </InputGroup.Append> */}

            </InputGroup>
            {touched && ((error && <p className="text-danger">{error}</p>) || (warning && <p className="text-danger">{warning}</p>))}
        </>
    );
};

FieldInputChange.defaultProps = {
    options: []
};


FieldInputChange.propTypes = {
    TypeOf: PropTypes.object,
    input: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    meta: PropTypes.object.isRequired,
    focus: PropTypes.bool,
    options: PropTypes.array,
    labelKey: PropTypes.string,
    isDisabled: PropTypes.bool
};



export default FieldInputChange;
